<template>
  <div class="profile-layout type-report">
    <main-navbar></main-navbar>
    <div class="wrapper report" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <!-- <mobile-menu :app="true"></mobile-menu> -->
        <template slot="links">
          <div class="profiles">
            <sidebar-item
              class="sidebar-item-plus"
              :link="{
                name: 'Prospect Search',
                icon: 'source',
                path: '/prospect-search',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Financial',
                icon: 'card_travel',
                path: '/new-profile/industry-financial-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Market',
                icon: 'leaderboard',
                path: '/new-profile/industry-market-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Companies',
                icon: 'business',
                path: '/company-search',
              }"
            ></sidebar-item>
            <div class="disable">
              <sidebar-item
                :link="{
                  name: 'Market',
                  icon: 'insights',
                  path: '/',
                }"
              ></sidebar-item>
              <sidebar-item
                :link="{
                  name: 'Franchise',
                  icon: 'store',
                  path: '/',
                }"
              ></sidebar-item>
            </div>
            <!-- <sidebar-item
              :link="{
                name: 'Valuation Multiple',
                icon: 'addchart',
                path: '/valuation-multiple',
              }"
            ></sidebar-item>-->
            <sidebar-item
              :link="{
                name: 'Financial Report',
                icon: 'text_snippet',
                path: '/create-report-format/financial',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Market Report',
                icon: 'newspaper',
                path: '/create-report-format/market',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Valuation Report',
                icon: 'request_quote',
                path: '/create-report-format/valuation',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Company Report',
                icon: 'summarize',
                path: '/create-report-format/company',
              }"
            ></sidebar-item>
          </div>
          <div class="section_wpr">My Data</div>
          <div class="profiles border-0">
            <sidebar-item
              :link="{
                name: 'Prospect List',
                icon: 'format_list_bulleted',
                path: '/my-prospect-lists',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Profiles',
                icon: 'folder_open',
                path: '/my-profiles',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Reports',
                icon: 'description',
                path: '/my-reports',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Data',
                icon: 'dns',
                path: '/my-data',
              }"
            ></sidebar-item>
          </div>
        </template>
      </side-bar>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path:
                '/valuation-report/' + this.id + '/vestimate-report-about-data',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Business Value',
              icon: 'developer_board',
              path: '/valuation-report/' + this.id + '/business-value',
              type: 'product',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'swot-analysis' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Scores',
                icon: 'star_half',
                path: '/valuation-report/' + this.id + '/scores',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'company-context' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Company-Context',
                icon: 'broken_image',
                path: '/valuation-report/' + this.id + '/company-context',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'market-insights' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Market Environment',
                icon: 'receipt_long',
                path: '/valuation-report/' + this.id + '/market-environment',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Financial Analysis',
              icon: 'pie_chart',
              path: '/valuation-report/' + this.id + '/finanical-analysis',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'KPI Details',
              icon: 'scatter_plot',
              path: '/valuation-report/' + this.id + '/kpi-details',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Valuation Approach',
              icon: 'info',
              path: '/valuation-report/' + this.id + '/vestimate-approach',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="loading || this.isRetail ? 'non-subscriber' : ''"
            :link="{
              name: 'Customize Report',
              icon: 'tune',
              path: !this.isRetail
                ? '/valuation-report/' + this.id + '/vestimate-customize-report'
                : this.currentPath,
              type: this.isRetail ? 'disabled' : 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Manage Inputs',
              icon: 'settings',
              path: '/valuation-report/' + this.id + '/vestimate-manage-inputs',
              type: 'product',
            }"
          ></sidebar-item>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- your content here -->
              <router-view
                :headerData="headerData"
                v-if="!loading || isAboutRoute"
              />
              <!-- <PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>  -->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

function initSidebar() {
  document.body.classList.toggle("sidebar-mini");
}

import MainNavbar from "./MainNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import { PulseLoader } from "@/components";
import Vuex, { mapActions } from "vuex";
import axios from "axios";

export default {
  components: {
    MainNavbar,
    ContentFooter,
    PulseLoader,
    MobileMenu,
  },
  data() {
    return {
      sidebarBackgroundColor: "grey",
      sidebarBackground: "green",
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      roles: [],
      expandNews: false,
      expandSingle: false,
      loading: true,
      isAboutRoute: false,
      headerData: [],
    };
  },
  methods: {
    ...mapActions({
      getVestimateReport: "user/getVestimateReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    init() {
      this.loading = true;
      this.getVestimateReport({
        report_id: this.$route.params.id,
      })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          if (res) {
            this.alertSuccess("Data loaded.");
          } else {
            this.alertError("An error occurred. We have been notified.");
          }
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({ isFinishedDate: true, productId: this.id });
        });
    },
    checkRoute() {
      if (this.$route.name === "VRAbouttheData") return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/productHeader", {
          params: {
            product_id: this.$route.params.id,
            session_id: localStorage.getItem("vue-authenticate.vueauth_access_token"),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  mounted() {
    // reinitScrollbar();
    // initSidebar();
    this.getHeaderData();
    this.isAboutRoute = this.checkRoute();
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
      isRetail: (state) =>
        state.user.user_type.retail/* || state.user.allow_retail*/ ? true : null,
    }),
    id() {
      return this.$route.params.id;
    },
    currentPath() {
      return this.$route.path;
    },
  },
  watch: {
    me: {
      handler: function(val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
    // sidebarMini() {
    //   this.minimizeSidebar();
    // },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.sidbar {
  .sidbar-box {
    .md-list-item-container:hover {
      background-color: #3e4345 !important;
    }

    .md-list-item-content {
      justify-content: center;
      flex-direction: column-reverse;
      &:hover,
      &:active {
        background-color: #3e4345 !important;
        .md-icon {
          color: #3b7ef1 !important;
          svg {
            fill: #3b7ef1 !important;
          }
        }
      }

      .md-icon {
        color: white !important;
        margin: 0 !important;
        svg {
          fill: white !important;
          &:hover,
          &:active {
            fill: #3b7ef1 !important;
          }
        }
      }
      p {
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}
.pulse {
  height: 120px !important;
  top: 1.7rem !important;
  background: transparent !important;
}
</style>
